import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-system-error',
    templateUrl: './system-error.component.html',
    styleUrls: ['./system-error.component.css'],
    standalone: false
})
export class SystemErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
